import { RECEIVE_IDENTITY_VERIFICATIONS, REQUEST_IDENTITY_VERIFICATIONS } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_IDENTITY_VERIFICATIONS:
            return { ...state, ...{ shouldFetch: false } }

        case RECEIVE_IDENTITY_VERIFICATIONS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, ...data, items }
        }
        default:
            return state
    }
}
